import './analysis-logs-table/analysis-logs-table.component';
import './analysis-logs-table/analysis-logs-table.scss';

import './analysis-logs-table-row/analysis-logs-table-row.component';
import './analysis-logs-table-row/analysis-logs-table-row.scss';

import './analysis-logs-view/analysis-logs-view.component';
import './analysis-logs-view/analysis-logs-view.scss';
